<div *ngIf="E2EExist==false">
    <div class="container-fluid my-4 text-center" style="margin-top:150px;height: 66vh" >
        <h3 style="font-family:Palatino Linotype,Book Antiqua, Palatino, serif;color:red;font-weight:bold">
        No E2E exists
        </h3>
        <h4 style="font-style:italic;color:black"> 
            Please reach out to <a href="mailto: automationjourney_dev@accenture.com">myWizardAJ.Support</a> for access.
        </h4>
    </div>
</div>
<div *ngIf="E2EExist==true" class="myw-section">
    <div class="row">
        <div class="col-xl-4 col-lg-4 col-6">
            <div class="form-group">
                <label class="form-label myw-required">Client Name</label> &nbsp;
                <input readonly type="text" class="form-control" maxlength="100" [(ngModel)]="clientName" >
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-6">
            <div class="form-group">
                <label class="form-label myw-required">Project Name</label> &nbsp;
                <!-- <img src="assets/images/info.svg" alt="information" placement="right"> -->
                <input type="text" class="form-control" maxlength="100" readonly [(ngModel)]="projectName">
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-6">
            <div class="form-group">
                <label class="form-label myw-required">Market</label> &nbsp;
                <input type="text" class="form-control" maxlength="100"  readonly [(ngModel)]="market">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-4 col-lg-4 col-6">
            <div class="form-group">
                <label class="form-label myw-required">Market Unit</label> &nbsp;
                <input type="text" class="form-control" maxlength="100" readonly [(ngModel)]="marketUnit">
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-6">
            <div class="form-group">
                <label class="form-label myw-required">Client Group</label> &nbsp;
                <!-- <img src="assets/images/info.svg" alt="information" placement="right"> -->
                <input type="text" class="form-control" maxlength="100" readonly [(ngModel)]="clientGroup" >
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-12 col-lg-4 col-6">
            <div class="form-group">
                <label class="form-label myw-required">User Access (Enterprise ID)</label> &nbsp;
                <input placeholder="Add the user name" (keydown.enter)="keyPress($event.target.value)" [(ngModel)]="user"  type="text" class="form-control" maxlength="100" >
            </div>
            <button type="button" class="btn btn-primary" [disabled]="!user" style="padding: 5px;margin-bottom: 20px;" (click)="saveOneUser()"
            >Add User</button>
        </div>
    </div>
    <div *ngIf="data.length>0" class="user-add">
        <div *ngFor="let i of data" class="chip">
            <!-- Content -->
            <div class="chip__content">{{i}}</div>
                <button (click)="deleteTodo(i)" class="chip__button">
                <div class="chip__button-line chip__button-line--first"></div>
                <div class="chip__button-line chip__button-line--second"></div>
            </button>
        </div>
    </div>
    <div class="myw-actions d-flex align-items-center" style="padding-top: 20px;">
        <button type="button" class="btn btn-primary ml-auto" (click)="saveUserDetails()"
            >Update Opportunity</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()"
            >Cancel</button>
    </div>
</div>